/**
 This code is using TypeScript to add an event listener to each element with the class "c-youtube__thumbnail". When the
 element is clicked, the event is prevented from happening and the element is removed from the parent element.
*/
import {Utils} from "./Utils";

Utils.executeWhenDocumentIsReady( () => {
    const thumbnails = document.querySelectorAll(".c-youtube__thumbnail")

    thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener("click", (event: Event) => {
            event.preventDefault()

            if (thumbnail.parentElement) {
                thumbnail.parentElement.removeChild(thumbnail)
            }
        })
    })
})
